import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {CardUsuarioComponent} from "./cmp-card-usuario/card-usuario.component";
import {NgStringPipesModule} from "../../../../../pipes/string/index";
import {ScrollEventModule} from "ngx-scroll-event";
import {FormUsuarioComponent} from "./cmp-form-usuario/form-usuario.component";
import {ListUsuarioComponent} from "./cmp-list-usuario/list-usuario.component";
import {MaterialModule} from "../../../../material.module";
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";
import {HelperListUsuarioComponent} from "./cmp-list-usuario/helper/helperListUsuario.component";
import {HelperFormUsuarioComponent} from "./cmp-form-usuario/helper/helperFormUsuario.component";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ScrollEventModule,
        NgStringPipesModule,
        MaterialModule,
        LoadingModule
    ],
    declarations: [ListUsuarioComponent,
        FormUsuarioComponent,
        CardUsuarioComponent,
        HelperListUsuarioComponent,
        HelperFormUsuarioComponent],
    exports: [CardUsuarioComponent]
})
export class UsuarioModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/usuario/usuario.module.ts